import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { UserCheckIcon, UserIcon } from '@yonderland/andes-icons';
import { Breakpoint, IconButton, LinkButton, useIsClient } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { NewAuthenticationContainer } from '../../containers/NewAuthenticationContainer';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
import { useOAuth } from '../../hooks/useOAuth';
import sessionActions from '../../redux/session/actions/SessionActions.creators';
import { makeGetLoggedInState } from '../../redux/session/selectors/SessionSelector';
import { NewAccountMenuPopover } from '../account/account-menu/NewAccountMenuPopover';
import { SecurityLevelsPopup } from '../security-levels-popup/SecurityLevelsPopup';
const AccountMenuItem = ({ accountMenu, login, registration, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const dispatch = useDispatch();
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const { authUrl, loggedIn: oauthLoggedIn, postLogin, logout } = useOAuth();
    const isClient = useIsClient();
    const loggedIn = useSelector(makeGetLoggedInState()) || oauthLoggedIn;
    const [open, setOpen] = useState(false);
    const handleLogout = () => {
        isNewAuth ? logout() : dispatch(sessionActions.createLogoutAction());
    };
    const handleOpen = () => {
        setOpen(prev => !prev);
    };
    const handleSidebarClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        if (isClient) {
            dispatch(sessionActions.createInitAction());
        }
    }, []);
    useEffect(() => {
        if (!loggedIn) {
            return;
        }
        postLogin();
    }, [loggedIn]);
    const triggerContent = (_jsxs(_Fragment, { children: [_jsx(Breakpoint, { from: "lg", children: _jsx(LinkButton, { testId: "login-button", theme: "neutral", variant: "tertiary", size: "sm", onClick: !isNewAuth || loggedIn
                        ? handleOpen
                        : isNewAuth && !loggedIn
                            ? () => (window.location.href = authUrl)
                            : undefined, iconLeft: isNewAuth && !loggedIn ? undefined : { source: loggedIn ? UserCheckIcon : UserIcon, size: 'xs' }, children: loggedIn ? t('account.account') : t('account.login.title.login') }) }), _jsx(Breakpoint, { until: "lg", children: _jsx(IconButton, { icon: {
                        title: 'user icon',
                        source: loggedIn ? UserCheckIcon : UserIcon,
                        size: 'xs',
                        color: 'subtle',
                        testId: 'account',
                    }, variant: "plain", size: "sm", onClick: !isNewAuth || loggedIn ? handleOpen : undefined }) })] }));
    return (_jsx(_Fragment, { children: isClient &&
            (loggedIn === true ? (_jsxs(_Fragment, { children: [_jsx(NewAccountMenuPopover, { items: accountMenu.items, logout: handleLogout, triggered: open, onClose: handleSidebarClose, children: triggerContent }), _jsx(SecurityLevelsPopup, {})] })) : (_jsx(_Fragment, { children: _jsx(NewAuthenticationContainer, { actionUri: (!!login && login.actionUri) || undefined, onClose: handleSidebarClose, registrationLink: (!!registration && registration.link) || undefined, triggered: open, children: triggerContent }) }))) }));
};
export default AccountMenuItem;
